@let canSearchForListings = canSearchForListings$ | async;
@let companyConfiguration = companyConfiguration$ | async;

<div class="landing-page" [class.landing-page--pure]="!canSearchForListings">

    <div class="landing-page-header" statusBarMode [whenNotVisible]="'Default'" [whenVisible]="'Dark'">

        <landing-toolbar class="landing-page-header-toolbar">
        </landing-toolbar>

        <div class="landing-page-header-block">

            <div class="landing-page-header-title rpc-title-font">
                {{'LANDING_PAGE.TITLES.MAIN' | translate}}
            </div>

        </div>

    </div>

    <!-- Don't remove neccessary for sticky form -->
    <div class="landing-page-form-anchor" #searchWrapper>
    </div>

    @if (isSearchSectionAvaliable) {
    <div class="landing-page-form-wrap" [class.landing-page-form-wrap--sticky]="isStickyHeader">

        <landing-search class="landing-page-form-component" [isSticky]="isStickyHeader">
        </landing-search>

    </div>
    }

    <div class="landing-page-body">

        <landing-section class="landing-page-section" [config]="lastViewedSectionConfig"
            [sectionData]="recentlyViewedListings$ | async" [isLoading]="isRecentlyViewedListingsLoading$ | async"
            [companyConfiguration]="companyConfiguration" (bannerButtonClicked)="onNavigateToSearchPage()">
        </landing-section>

        <landing-section class="landing-page-section" [config]="sectionConfigs.APPOINTMENTS"
            [sectionData]="upcomingNotDeclinedAppointmentsInfo$ | async | slice:0:sectionCardsToShow"
            [isLoading]="isAppointmentsLoading$ | async" [companyConfiguration]="companyConfiguration"
            (bannerButtonClicked)="onViewAllAppointments()" (sectionButtonCliked)="onViewAllAppointments()">
        </landing-section>

        <landing-section class="landing-page-section" [config]="sectionConfigs.MESSAGES"
            [sectionData]="sortedUnreadMessagesWithoutMineInfo$ | async | slice:0:sectionCardsToShow"
            [isLoading]="isCommentsLoading$ | async" [companyConfiguration]="companyConfiguration"
            (sectionButtonCliked)="onViewAllMessages()">
        </landing-section>

        @let upcomingListingsOpenHousesWithListings = upcomingListingsOpenHousesWithListings$ | async |
        slice:0:sectionCardsToShow;

        @if (upcomingListingsOpenHousesWithListings.length > 0) {
        <landing-section class="landing-page-section" [config]="sectionConfigs.OPEN_HOUSES"
            [sectionData]="upcomingListingsOpenHousesWithListings" [companyConfiguration]="companyConfiguration"
            (sectionButtonCliked)="onViewAllOpenHouses()">
        </landing-section>
        }

    </div>

</div>

<div class="landing-page-bottom-app">

    <div class="landing-page-bottom-app-content">

        <img class="landing-page-bottom-app-logo" src="assets/images/smart-banner/app-logo.svg" alt="" />

        <div class="landing-page-bottom-app-text">

            <div class="landing-page-bottom-app-title rpc-title-font">
                {{'LANDING_PAGE.TITLES.DONT_MISS_OUT_YOUR_DREAM' | translate}}
            </div>

            <div class="landing-page-bottom-app-note">
                {{'LANDING_PAGE.TITLES.DOWNLOAD_MOBILE_APP' | translate}}
            </div>

        </div>

        <div class="landing-page-bottom-app-actions">

            <div class="landing-page-bottom-app-apple" (click)="onMobileAppBannerClicked('ios')">

                <img src="assets/images/smart-banner/apple.svg" alt="">

            </div>

            <div class="landing-page-bottom-app-android" (click)="onMobileAppBannerClicked('android')">

                <img src="assets/images/smart-banner/android.svg" alt="">

            </div>

        </div>

    </div>

</div>

<additional-footer class="global-additional-footer">
</additional-footer>